import { Injectable } from '@angular/core';
import {
  MmAlertContentAlign,
  MmAlertMode,
  MmAlertService,
  MmAlertSize,
  MmAlertType,
} from '@metromarkets/components';
import { MmAlertConfig } from '@metromarkets/components/shared/custom-modules/alert/models/mm-alert-config.model';

import { ErrorResponse } from '~shared/modules/error-handler';
import { getErrorMsg } from '../utils';

@Injectable()
export class OrderHistoryAlertService {
  private readonly defaultAlertConfig = {
    size: MmAlertSize.large,
    mode: MmAlertMode.banner,
    duration: 4000,
    contentAlign: MmAlertContentAlign.center,
  };

  constructor(private alertService: MmAlertService,
  ) {
  }

  private openAlert(config: MmAlertConfig) {
    this.alertService.addAlert({
      ...this.defaultAlertConfig,
      ...config,
    });
  }

  public openErrorAlert(error: ErrorResponse) {
    const message = getErrorMsg(error);
    this.openAlert({
      type: MmAlertType.error,
      message,
    });
  }
}
